module.exports = __webpack_public_path__ + "img/default_bmc_logo_background.35069c90.jpg";